import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';

const FetchSuggestionsCommand = Command.extend({
  detail: {
    keywords: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.FETCH_SUGGESTIONS
  })
);

export {
  FetchSuggestionsCommand,
};
